module.exports = __webpack_public_path__ + "static/img/MY.e049e138.jpg";